import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const tiers = [{
  name: 'Tundra',
  price: '49',
  description: 'For small teams testing the waters.',
  features: ['3 campaigns', '5 regions', 'Basic weather triggers', 'Email support'],
  highlighted: false
}, {
  name: 'Glacier',
  price: '189',
  description: 'For growing brands scaling seasonal reach.',
  features: ['Unlimited campaigns', '40 regions', 'Advanced Glacial Analytics', 'Meridian Scheduler', 'Priority support'],
  highlighted: true
}, {
  name: 'Polar',
  price: '449',
  description: 'For enterprises dominating the winter.',
  features: ['Everything in Glacier', 'API access', 'Custom integrations', 'Dedicated account manager', 'SLA guarantee'],
  highlighted: false
}];
export function Pricing() {
  return <section id="pricing" className="py-24 px-6 relative z-10" data-id="element-104">
      <div className="container mx-auto max-w-7xl" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-107">
            Choose Your Expedition
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-lg" data-id="element-108">
            Transparent pricing for teams of all sizes. Scale your seasonal
            strategy without breaking the bank.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center max-w-6xl mx-auto" data-id="element-109">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative rounded-3xl p-8 ${tier.highlighted ? 'bg-navy-light border-2 border-ice shadow-[0_0_40px_rgba(77,168,218,0.2)] lg:scale-105 z-10' : 'glass-panel'}`} data-id="element-110">
              {tier.highlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-ice text-navy text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full" data-id="element-111">
                  Recommended
                </div>}

              <div className="mb-8" data-id="element-112">
                <h3 className="text-2xl font-semibold text-frost mb-2" data-id="element-113">
                  {tier.name}
                </h3>
                <p className="text-white/60 text-sm h-10" data-id="element-114">{tier.description}</p>
              </div>

              <div className="mb-8 flex items-baseline gap-1" data-id="element-115">
                <span className="text-4xl font-bold text-white" data-id="element-116">
                  €{tier.price}
                </span>
                <span className="text-white/50" data-id="element-117">/mo</span>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-118">
                {tier.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3 text-white/80 text-sm" data-id="element-119">
                    <CheckIcon className={`w-5 h-5 shrink-0 ${tier.highlighted ? 'text-ice' : 'text-white/40'}`} data-id="element-120" />
                    <span data-id="element-121">{feature}</span>
                  </li>)}
              </ul>

              <button className={`w-full py-3 px-6 rounded-xl font-semibold transition-all duration-300 ${tier.highlighted ? 'bg-ice hover:bg-ice-light text-navy shadow-[0_0_15px_rgba(77,168,218,0.3)]' : 'bg-white/10 hover:bg-white/20 text-white'}`} data-id="element-122">
                Get Started
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}